import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [import('./viewer/Group' /* webpackChunkName: "Group" */)],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('Group', UiTypes),
};

export default entry;
